import React from "react";
import { TextField, Box } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../HelpText/HelpText";

function NumTrapsPerString({ numTrapsPerString, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">
        {getFieldLabel("effort", "numTrapsPerString")}
      </h2>
      <TextField
        name="numTrapsPerString"
        variant="standard"
        inputProps={{
          min: 1,
          style: { textAlign: "center" },
        }}
        size="small"
        type="number"
        value={numTrapsPerString}
        onChange={handleChange}
      />
      <HelpText
        helpText={getFieldLabel("effort", "numTrapsPerString", "helptext")}
      />
    </Box>
  );
}

export default NumTrapsPerString;
